// extracted by mini-css-extract-plugin
module.exports = {"title":"Aide_title__1Hta9","margin":"Aide_margin__31dKD","select":"Aide_select__3btZJ","mobile":"Aide_mobile__uFzcY"};